import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../../Context/MessageContext';
import Axios from 'axios';
import Config from '../../../Config/Config';
import { useMsal } from "@azure/msal-react";

const useListBadgeOfMerits = () => {

    const rootPath = Config.api.rootPath;
    const { instance } = useMsal();
    const { t } = useTranslation();
    const { addMessage, removeMessage } = useContext(MessageContext);
    const [ badgeOfMerits, setBadgeOfMerits ] = useState([]);
    const [ fetchingBadgeOfMerits, setFetchingBadgeOfMerits ] = useState(true);

    /** list contracts
    * @returns {array} - array of one to Ones */ 
    const listBadgeOfMerits = async (userID) => {
        try {

            const msgId = addMessage({ type: "loading", header: t('general.moment'), body: t('info.fetchingBadgeOfMerits')});
            
            const activeAccount = instance.getActiveAccount();
            const accounts = instance.getAllAccounts();

            if (!activeAccount && accounts.length === 0) return;

            const request = {
                scopes: Config.api.scopes,
                account: activeAccount || accounts[0]
            }

            const authResult = await instance.acquireTokenSilent(request);

            const options = {
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + authResult.accessToken
                }
            }

            let result = null;

            result = await Axios.get(rootPath + "/api/v1/users/" + userID + "/badgeofmerits", options);

            removeMessage(msgId);

            if (result && result.status === 200) {
                setBadgeOfMerits(result.data);
                setFetchingBadgeOfMerits(false);
                return result;
            }

            if (result && result.status === 404) {
                addMessage({ type: "warning", header: t('general.error'), body: t('warnings.badgeOfMeritsNotFound') });
                setFetchingBadgeOfMerits(false);
                return result;
            }

            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingBadgeOfMeritsFailed') });
            setFetchingBadgeOfMerits(false);
            return result;

        } catch (error) {
            if (Config.environment === 'development' || Config.environment === 'test') console.log(error);
            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingBadgeOfMeritsFailed') });
            setFetchingBadgeOfMerits(false);
            return error;
        }
    }

    return { badgeOfMerits, fetchingBadgeOfMerits, listBadgeOfMerits };

}

export default useListBadgeOfMerits;
